import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Youtube, MessageCircle, Music2, ArrowRight } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useLang } from "../i18n/LanguageContext";

export const PLATFORM_META = {
  facebook: { name: "Facebook", Icon: Facebook, color: "#1877F2", cta: "Like our page", blurb: "Event albums, live streams and community news." },
  instagram: { name: "Instagram", Icon: Instagram, color: "#E1306C", cta: "Follow", blurb: "Kente, drums and the faces of Okuapem in Massachusetts." },
  twitter: { name: "X (Twitter)", Icon: Twitter, color: "#0F1419", cta: "Follow", blurb: "Quick notices, meeting reminders and festival dates." },
  youtube: { name: "YouTube", Icon: Youtube, color: "#FF0000", cta: "Subscribe", blurb: "Ceremonies, durbars and highlights from our gatherings." },
  whatsapp: { name: "WhatsApp Community", Icon: MessageCircle, color: "#25D366", cta: "Join community", blurb: "Official announcements straight to your phone." },
  tiktok: { name: "TikTok", Icon: Music2, color: "#010101", cta: "Follow", blurb: "Short clips of our culture, food and celebrations." },
};

export function FollowStrip() {
  const { data } = useApi("/settings/social");
  const { t } = useLang();
  const links = Object.entries(data || {}).filter(([, v]) => v);
  if (links.length === 0) return null;
  return (
    <section className="border-y border-gold/25 bg-crimson text-parchment" data-testid="follow-strip">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-4 px-6 py-5 lg:px-8">
        <div className="mr-auto">
          <p className="eyebrow text-gold">{t("Stay connected")}</p>
          <p className="font-serif-display text-xl font-bold">{t("Follow the association online")}</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {links.map(([k, url]) => { const m = PLATFORM_META[k]; return m && (
            <a key={k} href={url} target="_blank" rel="noreferrer" aria-label={m.name} data-testid={`follow-strip-${k}`}
              className="flex h-11 w-11 items-center justify-center rounded-full bg-parchment/10 text-parchment transition-all hover:-translate-y-0.5 hover:bg-gold hover:text-crimson"><m.Icon size={20} /></a>); })}
          <Link to="/contact/connect" className="ml-2 inline-flex items-center gap-1 rounded-full bg-gold px-4 py-2 text-sm font-semibold text-crimson hover:bg-gold-bright" data-testid="follow-strip-more">{t("Connect with us")} <ArrowRight size={15} /></Link>
        </div>
      </div>
    </section>
  );
}
